import * as XLSX from 'xlsx';

interface PDFData {
	date: string;
	monitorings: number;
	maintenances: number;
	monitoringValue: number;
	maintenanceValue: number;
	dailyTotal: number;
}

interface XLSXOptions {
	dateInitial: Date;
	dateFinal: Date;
	clientName?: string;
	totalIncome: number;
	monitoringUnitValue: number;
	maintenanceUnitValue: number;
}

export const generateFinancialXLSX = (
	data: PDFData[],
	options: XLSXOptions
): void => {
	// Prepara os dados da tabela principal
	const tableData = data.map((item) => ({
		DATA: item.date,
		'QTD. MONITORAMENTOS': item.monitorings,
		'QTD. MANUTENÇÕES': item.maintenances,
		'VALOR MONITORAMENTO (R$)': item.monitoringValue,
		'VALOR MANUTENÇÃO (R$)': item.maintenanceValue,
		'TOTAL DIÁRIO (R$)': item.dailyTotal,
	}));

	// Calcula os totais
	const totalMonitorings = data.reduce(
		(sum, item) => sum + item.monitorings,
		0
	);
	const totalMaintenances = data.reduce(
		(sum, item) => sum + item.maintenances,
		0
	);
	const totalMonitoringValue = data.reduce(
		(sum, item) => sum + item.monitoringValue,
		0
	);
	const totalMaintenanceValue = data.reduce(
		(sum, item) => sum + item.maintenanceValue,
		0
	);

	// Prepara os dados do resumo
	const summaryData = [
		{
			DESCRIÇÃO: 'Período Inicial',
			VALOR: options.dateInitial.toLocaleDateString('pt-BR'),
		},
		{
			DESCRIÇÃO: 'Período Final',
			VALOR: options.dateFinal.toLocaleDateString('pt-BR'),
		},
		{ DESCRIÇÃO: 'Cliente', VALOR: options.clientName || 'Não informado' },
		{
			DESCRIÇÃO: 'Valor Unitário Monitoramento (R$)',
			VALOR: options.monitoringUnitValue,
		},
		{
			DESCRIÇÃO: 'Valor Unitário Manutenção (R$)',
			VALOR: options.maintenanceUnitValue,
		},
		{ DESCRIÇÃO: '', VALOR: '' },
		{ DESCRIÇÃO: 'Total de Monitoramentos', VALOR: totalMonitorings },
		{ DESCRIÇÃO: 'Total de Manutenções', VALOR: totalMaintenances },
		{
			DESCRIÇÃO: 'Valor Total Monitoramentos (R$)',
			VALOR: totalMonitoringValue,
		},
		{
			DESCRIÇÃO: 'Valor Total Manutenções (R$)',
			VALOR: totalMaintenanceValue,
		},
		{ DESCRIÇÃO: 'VALOR TOTAL GERAL (R$)', VALOR: options.totalIncome },
	];

	// Cria uma nova planilha
	const workbook = XLSX.utils.book_new();

	// Converte os dados da tabela principal para sheet
	const mainSheet = XLSX.utils.json_to_sheet(tableData);
	// Converte os dados do resumo para sheet
	const summarySheet = XLSX.utils.json_to_sheet(summaryData);

	// Ajusta a largura das colunas da planilha principal
	mainSheet['!cols'] = [
		{ wch: 12 }, // DATA
		{ wch: 20 }, // QTD. MONITORAMENTOS
		{ wch: 18 }, // QTD. MANUTENÇÕES
		{ wch: 22 }, // VALOR MONITORAMENTO
		{ wch: 20 }, // VALOR MANUTENÇÃO
		{ wch: 18 }, // TOTAL DIÁRIO
	];

	// Adiciona as sheets ao workbook
	XLSX.utils.book_append_sheet(workbook, mainSheet, 'Financeiro Detalhado');
	XLSX.utils.book_append_sheet(workbook, summarySheet, 'Resumo');

	// Gera o arquivo XLSX
	const fileName = `relatorio_financeiro_${options.dateInitial.toISOString().split('T')[0]}_a_${options.dateFinal.toISOString().split('T')[0]}.xlsx`;
	XLSX.writeFile(workbook, fileName);
};

// Função para preparar os dados (mantida igual)
export const preparePDFData = (
	chartData: any[],
	monitoringUnitValue: number,
	maintenanceUnitValue: number
): PDFData[] => {
	return chartData.map((item) => {
		const monitoringValue = item.monitorings * monitoringUnitValue;
		const maintenanceValue = item.maintenances * maintenanceUnitValue;
		const dailyTotal = monitoringValue + maintenanceValue;

		return {
			date: new Date(item.date).toLocaleDateString('pt-BR'),
			monitorings: item.monitorings,
			maintenances: item.maintenances,
			monitoringValue,
			maintenanceValue,
			dailyTotal,
		};
	});
};
